import {
    Box, IconButton, AppBar, Toolbar, Typography,
    useMediaQuery, Avatar, Tooltip, Chip, Stack,
} from "@mui/material";
import { useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { setSelectUser, setOpenTagModal, clearChats } from "../messagesSlice";
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import { useDispatch, useSelector } from "react-redux";
import AssignTagModal from "./addTagModal";
import { useRef } from "react";
import { setOpenLeadChatConvo } from "../../leadMangement/leadMangementSlice";
import CloseIcon from "@mui/icons-material/Close";
// import ContactEditModal from "../../contact/components/contactEdit";
import ContactProfileTabModal from '../../contactProfile/contactProfileTabModal';
import { getIndividualUserThunk } from "../../contact/contactThunk";

const tagColors = [
    "#ff6b6b", "#4ecdc4", "#45b7d1", "#feca57",
    "#5f27cd", "#1dd1a1", "#ff9f43", "#54a0ff",
    "#e84393", "#10ac84"
];
const getTagColor = (index) => tagColors[index % tagColors.length];


// Predefined color palette
const avatarColors = [
    "#dc2626", "#db2777", "#9333ea", "#7c3aed",
    "#4f46e5", "#2563eb", "#0284c7", "#0891b2",
    "#0d9488", "#16a34a", "#65a30d", "#ca8a04",
    "#d97706", "#ea580c", "#c2410c", "#475569"
];

// Function to generate a color based on a string (name or ID)
const getAvatarColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % avatarColors.length;
    return avatarColors[index];
};


const ConvoNavBar = () => {
    const isMobile = useMediaQuery("(max-width:899.95px)"); // same breakpoint as whatsAppLayout (md)
    const dispatch = useDispatch();
    const scrollRef = useRef(null);
    const { selectedUser, addTagModal, waMessageContacts } = useSelector((state) => state.messages);
    const { openLeadChatConvo } = useSelector(
        (state) => state.leadManagement
    );

    const [openModal, setOpenModal] = useState(false);
    const [rowData, setRowData] = useState(null);

    const handleOpenModal = () => {
        setRowData(contact);
        setOpenModal(true);
    };
    const handleBack = () => dispatch(setSelectUser(null));
    const openTagModal = () => dispatch(setOpenTagModal(true));

    const contact = waMessageContacts.find((item) => item.wa_contact_id === selectedUser);

    const tags = contact?.tag_names
        ? Array.isArray(contact.tag_names)
            ? contact.tag_names
            : contact.tag_names.split(",").map(t => t.trim())
        : [];

    const visibleTags = tags.slice(0, 5); // Show first 5 tags
    const remainingCount = tags.length - visibleTags.length;

    const handleClick = () => {
        dispatch(getIndividualUserThunk({ wa_contact_id: selectedUser }));
    }



    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar
                position="static"
                sx={{
                    backgroundColor: "#fff",
                    color: "#0f172a",
                    boxShadow: "none",
                    height: 58,
                    borderRadius: 0,
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
            >
                <Toolbar sx={{ minHeight: "58px !important", px: { xs: 1.5, sm: 2 }, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}>

                    {/* Left: Avatar + Name, with mobile number underneath */}
                    <Box sx={{ display: "flex", alignItems: "center", overflow: "hidden", flex: 1, minWidth: 0 }} onClick={handleClick}>
                        <Tooltip title="Update Profile" placement="top">
                            {isMobile ? (
                                <IconButton
                                    onClick={() => {
                                        if (openLeadChatConvo) {
                                            dispatch(setOpenLeadChatConvo(false));
                                            dispatch(clearChats());
                                        } else {
                                            handleBack();
                                        }
                                    }}
                                    sx={{ mr: 1, color: "#475569" }}
                                >
                                    <ArrowBackIcon fontSize="small" />
                                </IconButton>
                            ) : (
                                <Avatar
                                    src={contact?.avatarUrl}
                                    alt={contact?.name}
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        mr: 1.25,
                                        flexShrink: 0,
                                        cursor: "pointer",
                                        fontSize: 16,
                                        fontWeight: 800,
                                        color: getAvatarColor(contact?.name + contact?.wa_contact_id),
                                        bgcolor: `${getAvatarColor(contact?.name + contact?.wa_contact_id)}1f`,
                                        transition: "opacity .15s ease",
                                        "&:hover": { opacity: 0.85 },
                                    }}
                                    onClick={handleOpenModal}
                                >
                                    {String(contact?.name || contact?.mobile || "?").trim().charAt(0).toUpperCase()}
                                </Avatar>
                            )}
                        </Tooltip>

                        <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography
                                variant="subtitle1"
                                noWrap
                                sx={{ fontSize: 15, fontWeight: 700, lineHeight: 1.3, color: "#0f172a", cursor: "pointer", width: "fit-content", maxWidth: "100%", "&:hover": { color: "#2563eb" } }}
                                onClick={handleOpenModal}
                            >
                                {contact?.name ?? contact?.mobile}
                            </Typography>

                            {/* Second line: mobile number */}
                            <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mt: 0.25, minWidth: 0, overflow: "hidden" }}>
                                {contact?.name && contact?.mobile && (
                                    <Typography variant="caption" sx={{ color: "#64748b", flexShrink: 0, lineHeight: 1.4 }}>
                                        {contact.mobile}
                                    </Typography>
                                )}
                            </Stack>
                        </Box>
                    </Box>

                    {/* Contact Edit Modal */}
                    <ContactProfileTabModal
                        show={openModal}
                        handleClose={() => setOpenModal(false)}
                        rowData={rowData}
                        type="waContacts"
                    />

                    {/* Right: Tags */}
                    {tags.length > 0 && (
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0.75}
                            sx={{ flexShrink: 1, minWidth: 0, maxWidth: { xs: "40%", sm: "50%", md: "55%" } }}
                        >
                        {/* "Tags:" label stays fixed; the chips scroll if there are many */}
                        <Typography variant="body2" sx={{ color: "#64748b", fontSize: 12, fontWeight: 600, flexShrink: 0, display: { xs: "none", sm: "block" } }}>
                            Tags:
                        </Typography>
                        <Box
                            ref={scrollRef}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: 0.75,
                                flexShrink: 1,
                                minWidth: 0,
                                overflowX: "auto",
                                whiteSpace: "nowrap",
                                scrollBehavior: "smooth",
                                "&::-webkit-scrollbar": { display: "none" },
                            }}
                        >
                            {visibleTags.map((tag, idx) => (
                                <Chip
                                    key={idx}
                                    label={tag}
                                    size="small"
                                    sx={{
                                        backgroundColor: `${getTagColor(idx)}1f`,
                                        color: getTagColor(idx),
                                        border: `1px solid ${getTagColor(idx)}40`,
                                        fontSize: 11,
                                        fontWeight: 700,
                                        height: 22,
                                        flexShrink: 0,
                                    }}
                                />
                            ))}
                            {remainingCount > 0 && (
                                <Tooltip title={tags.slice(5).join(", ")}>
                                    <Chip
                                        label={`+${remainingCount}`}
                                        size="small"
                                        sx={{
                                            backgroundColor: "#f1f5f9",
                                            color: "#475569",
                                            border: "1px solid #e2e8f0",
                                            fontSize: 11,
                                            fontWeight: 700,
                                            height: 22,
                                            flexShrink: 0,
                                        }}
                                    />
                                </Tooltip>
                            )}
                        </Box>
                        </Stack>
                    )}

                    {/* Right: Buttons */}
                    <Box sx={{ display: "flex" }}>
                        {/* <IconButton sx={{ ml: 1 }} color="inherit" size="small" onClick={openTagModal}>
                            <Tooltip title="Update Tag"><StyleIcon fontSize="small" /></Tooltip>
                        </IconButton> */}
                        <IconButton sx={{ ml: 1, color: "#64748b" }} size="small">
                            {/* <Tooltip title="Search With Chat"><SearchIcon fontSize="small" /></Tooltip> */}

                            {
                                contact?.organisation_ids !== null && <Tooltip title={`${contact?.organisation_names}`}><CorporateFareIcon /></Tooltip>
                            }
                        </IconButton>
                        {
                            openLeadChatConvo && (
                                <IconButton sx={{ ml: 1 }} color="inherit" size="small" onClick={() => { dispatch(setOpenLeadChatConvo(false)); dispatch(clearChats()) }}>
                                    <Tooltip title="Close"><CloseIcon /></Tooltip>
                                </IconButton>
                            )
                        }
                    </Box>
                </Toolbar>
            </AppBar>

            <AssignTagModal show={addTagModal} handleClose={() => dispatch(setOpenTagModal(false))} />
        </Box>
    );
};

export default ConvoNavBar;
